module.exports = __webpack_public_path__ + "img/Symbol1.c6c5d886.svg";